"use strict";
import CartModalController from 'emun.cart/cart-modal.controller.es6'
import shoppingConfig from 'emun.shopping/shopping.config'

class PaymentMethodPromptController extends CartModalController {
    constructor($session, $cart, $geo, $dates, $uibModalInstance, options) {
        'ngInject';
        super($session, $cart, $uibModalInstance, options);
        let $ctrl = this;
        $ctrl.$geo = $geo;
        $ctrl.months = $dates.monthNumbers;
        $ctrl.years = $dates.getYears();
        $ctrl.shoppingConfig = shoppingConfig;
        if($ctrl.request){
            $ctrl.prompt[$ctrl.request.id ? 'editing' : 'creating'].notify($ctrl);
            if(options && options.request && options.request.name) {
                if(!$ctrl.request.companyName)  $ctrl.request.companyName= options.request.name;
            }
        }
    }

    submit() {
        let $ctrl = this;
        return $ctrl.$cart.applyPaymentMethod($ctrl.request).then(res => {
            $ctrl.prompt[$ctrl.request.id ? 'edited': 'created'].notify(res);
            $ctrl.$close(res);
        });
    }
}

function PaymentMethodPromptFactory($q, modals) {
    'ngInject';
    class PaymentMethodPrompt {
        constructor() {
            var me = this;
            //promises
            ['editing', 'creating', 'edited','created'].forEach(k => {
                me[k] = $q.defer();
                me[k].on = me[k].subscribe = me[k].sub = cb => me[k].promise.finally(null, cb);
            });
        }
        open(options) {
            let prompt = this;
            console.warn('prompt open(options', options);
            console.warn('payment-method-prompt');
            let modalInstance = prompt.modal = modals.open({
                size: 'md',
                templateUrl: 'payment-method-prompt.html',
                controller: PaymentMethodPromptController,
                bindToController: true,
                controllerAs: '$ctrl',
                resolve: {
                    options: () => angular.extend({prompt},options)
                }
            });

            return modalInstance.result;
        }
    }
    return PaymentMethodPrompt;
}

function PaymentMethodPromptDirectiveFactory(PaymentMethodPrompt, $parse) {
    return {
        restrict: 'EA',
        scope: false,
        link: function (scope, element, attr) {
            var prompt = new PaymentMethodPrompt();
            attr.onEdited && me.edited.subscribe(args => $parse(attr.onEdited)(scope, args));
            attr.onCreated && me.created.subscribe(args => $parse(attr.onCreated)(scope, args));
            attr.ngModel && $parse(attr.ngModel).assign(scope, prompt);

            var $targets = (attr.clickSelector ? element.find(attr.clickSelector) : element);
            $targets.on('click', e => prompt.open({
                title: attr.title,
                request: scope.$eval(attr.paymentMethod)
            }));
        }
    }
}

angular.module('emun.cart')
    .factory('PaymentMethodPrompt', PaymentMethodPromptFactory)
    .directive('paymentMethodPrompt', PaymentMethodPromptDirectiveFactory);